import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Home } from './components/Home.js';
import Concept from './components/Concept.js';
import MenuPage from './components/MenuPage.js';
import Reservation from './components/Reservation.js';
import Symptoms from './components/Symptoms.js';
import SymptomLowBackPain from './components/SymptomLowBackPain.js';
import SymptomShoulderPain from './components/SymptomShoulderPain.js';
import SymptomNeckPain from './components/SymptomNeckPain.js';
import SymptomKneePain from './components/SymptomKneePain.js';
import Treatments from './components/Treatments.js';
import Access from './components/Access.js';
import CampaignNerveTherapy from './components/CampaignNerveTherapy.js';
import CampaignFacialCare from './components/CampaignFacialCare.js';
import CampaignFullBodyBalance from './components/CampaignFullBodyBalance.js';


const App = () => {

    return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/concept" component={Concept}/>
                    <Route exact path="/treatments" component={Treatments}/>
                    <Route exact path="/menu" component={MenuPage}/>
                    <Route exact path="/symptoms" component={Symptoms}/>
                    <Route exact path="/symptoms/low-back-pain" component={SymptomLowBackPain}/>
                    <Route exact path="/symptoms/shoulder-pain" component={SymptomShoulderPain}/>
                    <Route exact path="/symptoms/neck-pain" component={SymptomNeckPain}/>
                    <Route exact path="/symptoms/knee-pain" component={SymptomKneePain}/>
                    <Route exact path="/reservation" component={Reservation}/>
                    <Route exact path="/access" component={Access}/>
                    <Route exact path="/campaign/nerve-therapy-trial" component={CampaignNerveTherapy}/>
                    <Route exact path="/campaign/facial-care" component={CampaignFacialCare}/>
                    <Route exact path="/campaign/full-body-balance" component={CampaignFullBodyBalance}/>
                </Switch>
            </BrowserRouter>

    );
}

export default App;
